import { isNil } from 'lodash';

export const buildQueryString = (params: Record<string, any>): string =>
  Object.entries(params ?? {})
    .filter(([, value]) => !isNil(value))
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
